import './tallguyandgrill1/style';
import FormStructure from './tallguyandgrill1/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js